module.exports = __webpack_public_path__ + "img/camping-2.b6634dc4.jpg";